module.exports = __webpack_public_path__ + "static/img/beian.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/beian.png
// module id = 5qVt
// module chunks = 0